// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"PolicyGroupTemplates__toolbar","countItemsLabel":"PolicyGroupTemplates__countItemsLabel","groupPolicyTemplateList":"PolicyGroupTemplates__groupPolicyTemplateList"};